import styled from "styled-components"

import { minWidth } from "utils"

export const AccountMenuContainer = styled.div`
  width: 100%;
  height: 100%;
`

export const MenuButton = styled.button`
  display: flex;
  align-items: center;
  height: 3rem;
  border: none;
  padding: 0;

  ${minWidth.hamburgerLarge`
    display: flex;
    align-items: center;
  `}
`

export const AccountText = styled.p`
  margin-right: 0.5rem;
  display: none;
  font-size: 1.6rem;

  ${minWidth.hamburgerLarge`
    display: block;
  `}
`

export const Menu = styled.ul`
  width: 100%;
  background: #fff;
  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.1);
  padding: 0;
  list-style: none;
  border-top: 1px solid #ccc;
  position: absolute;

  left: 0;
  z-index: 6;

  ${minWidth.hamburgerLarge`
    border: none;
    overflow-y: none;
    width: 16rem;
    top: 5rem;
    left: unset;
    right: 4.5rem;
  `}

  li {
    font-weight: 500;
    font-size: 1.4rem;
    color: #000;
    text-transform: uppercase;
    padding: 2rem;

    ${minWidth.hamburgerLarge`
      font-weight: 400;
      font-size: 1.2rem;
      padding: 0.8rem 1.7rem;
    `}

    a:hover {
      text-decoration: underline;
    }

    p {
      ${minWidth.hamburgerLarge`
        display: none;
      `}

      font-weight: 400;
      text-transform: none;
      margin: 0.6rem 0 0 0;
    }
  }
`
export const ItemContainer = styled.div`
  border-bottom: 1px solid #eee;

  ${minWidth.mobile`
    border: none;
  `}
`

export const ViewMoreInfoLink = styled.button`
  display: none;
  width: 100%;
  border-top: 1px solid #ccc;
  margin-top: 0.6rem;
  padding: 1.5rem 1.7rem;
  text-align: left;
  font-size: 12px;
  color: #222;
  line-height: 16.2px;

  ${minWidth.hamburgerLarge`
    display: block;
  `}
`
